import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { LOAD_ARTICLES } from "models/queries/article.queries";
import { Link } from "react-router-dom";
import "./get-articles.component.scss";
import { formatArticleDate, IArticle } from "sthinds.io-lib";
import { articlePath } from "../body/article/article-url";

// TODO: try react-redux useSelector and useDispatch to manage Redux store from functional component

function GetArticles(): JSX.Element {
  // TODO: move mutations and queries to an external injectable service
  const { error, loading, data } = useQuery(LOAD_ARTICLES);

  const [articles, setArticles] = useState([]);

  useEffect(() => {
    if (data && data.articles && data.articles.length > 0) {
      const articlesSorted = data.articles.toSorted(
        (a: IArticle, b: IArticle) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        }
      );
      setArticles(articlesSorted);
    } else {
      setArticles([]);
    }
  }, [data]);

  if (loading) {
    return <p className="article-index-status">Loading posts…</p>;
  }
  if (error) {
    return (
      <p className="article-index-status" role="alert">
        Posts could not be loaded. Please try again shortly.
      </p>
    );
  }

  return (
    <nav className="article-nav">
      <ul className="article-list">
        {articles.map((article: Record<string, string>) => (
          <li key={article._id} className="article-list-item">
            <Link to={articlePath(article as IArticle)}>
              <h3 className="get-articles-article-title">{article.title}</h3>
              <p className="get-articles-article-subtitle">
                {article.subtitle}
              </p>
              <span className="date-span">
                {formatArticleDate(article.date)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default GetArticles;
